<template>
  <div class="backtop" @click="scrolltop" v-show="btnFlag" id="backtop">
    <i class="el-icon-arrow-up"></i>
  </div>
</template>

<script>
export default {
  name: "BackTop",
  data() {
    return {
      btnFlag: false,
    };
  },
  mounted() {
    window.addEventListener("scroll", this.backtop);
  },
  destroyed() {
    window.removeEventListener("scroll", this.backtop);
  },
  methods: {
    backtop() {
      const that = this;
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      that.scrollTop = scrollTop;
      var controY = document.documentElement.scrollHeight; //代表整个滚动条多长
      var pageView = document.documentElement.clientHeight;
      var bottomY =
        document.documentElement.scrollHeight -
        document.documentElement.scrollTop -
        document.documentElement.clientHeight;

      if (that.scrollTop > 60) {
        that.btnFlag = true;
        if (bottomY > 0) {
          document.getElementById("backtop").className = "backtop";
        } else {
          document.getElementById("backtop").className = "pc-back";
        }
      } else {
        that.btnFlag = false;
      }
    },

    scrolltop() {
      var scrolltopTemp =
        document.documentElement.scrollTop || document.body.scrollTop; //滚动高度
      var timer = setInterval(function() {
        let osTop =
          document.documentElement.scrollTop || document.body.scrollTop;
        let ispeed = Math.floor(-osTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop =
          osTop + ispeed;
        this.isTop = true;
        if (osTop === 0) {
          clearInterval(timer);
        }
      }, 20);
    },
  },
};
</script>

<style lang="less" scoped>
@media screen and (max-width: 768px) {
  .backtop {
    background: #00a5e5;
    height: 0.9rem;
    width: 0.9rem;
    right: 0.1rem;
    bottom: 1rem;
    font-size: 0.5rem;
    color: #ffffff;
    text-align: center;
    line-height: 0.9rem;
    cursor: pointer;
    margin: 0.1rem;
    position: fixed;
    right: 0.1rem;
    z-index: 999;
    font-weight: bold !important;
    .el-icon-arrow-up {
      font-size: 25px;
      font-weight: bold;
    }
  }
  .pc-back {
    background: #00a5e5;
    height: 0.9rem;
    width: 0.9rem;
    right: 0.1rem;
    bottom: 8.5rem;
    font-size: 0.3rem;
    color: #ffffff;
    text-align: center;
    line-height: 0.9rem;
    cursor: pointer;
    margin: 0.1rem;
    position: fixed;
    right: 0.1rem;
    z-index: 999;
    .el-icon-arrow-up {
      font-size: 25px;
      line-height: .9rem;
      font-weight: bold;
    }
  }
}
@media screen and (min-width: 768px) {
  .backtop {
    background: #00a5e5;
    height: 0.4rem;
    width: 0.4rem;
    right: 0.1rem;
    bottom: 0.8rem;
    font-size: 0.3rem;
    color: #ffffff;
    text-align: center;
    line-height: 0.4rem;
    cursor: pointer;
    margin: 0.1rem;
    position: fixed;
    right: 0.1rem;
    z-index: 999;
  }
  .pc-back {
    background: #00a5e5;
    height: 0.4rem;
    width: 0.4rem;
    right: 0.1rem;
    bottom: 2rem;
    font-size: 0.3rem;
    color: #ffffff;
    text-align: center;
    line-height: 0.4rem;
    cursor: pointer;
    margin: 0.1rem;
    position: fixed;
    right: 0.1rem;
    z-index: 999;
  }
}
</style>